import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SpeakAction } from '../../../../../../models/interactions.model';
import { HighlightVariablesPipe } from '../../../../../../pipes/highlight-variables.pipe';
import { FlowActionCardComponent } from '../flow-action-card/flow-action-card.component';

@Component({
  selector: 'app-flow-speak-action',
  imports: [FlowActionCardComponent, HighlightVariablesPipe],
  templateUrl: './flow-speak-action.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlowSpeakActionComponent {
  readonly data = input.required<SpeakAction>();
}
